<template>
  <div class="contents">
    <div class="layout">
      <!-- s::title-breadcrumbs -->
      <div class="page-top">
        <h2>스페셜 관리</h2>
        <div class="breadcrumbs">
          <span>컨텐츠 관리</span>
          <span>스페셜 관리</span>
          <span class="color-black">{{ articleUuid ? item.title : '등록' }}</span>
        </div>
      </div>
      <!-- e::title-breadcrumbs -->

      <div class="white-panel mt30">
        <div class="table-wrap">
          <table class="table-type2">
            <colgroup>
              <col style="width:150px;">
              <col>
            </colgroup>
            <tbody>
            <tr>
              <th>제목<em class="required">*</em></th>
              <td>
                <input type="text" v-model="item.title"/>
              </td>
            </tr>
            <tr>
              <th>부제목<em class="required">*</em></th>
              <td>
                <input type="text" v-model="item.subTitle"/>
                <a v-show="item.subTitle"
                   :href="`https://article21.kr/article/special/share/${item.uuid}/${encodeURIComponent(item.subTitle)}`"
                   target="_blank">
                  🔗 스페셜 링크 페이지(비공개여도 보임. 단 부제목 유지)
                </a>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top;">프리뷰 컨텐츠 타입<em class="required">*</em></th>
              <td>
                <select v-model="item.previewContentType" @change="handlePreviewContentTypeChange" required>
                  <option value="" disabled>선택해주세요</option>
                  <option value="IMAGE">이미지</option>
                  <option value="VIDEO">비디오</option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top;">프리뷰 컨텐츠<em class="required">*</em></th>
              <td>
                <!-- 이미지 선택 -->
                <div v-if="item.previewContentType === 'IMAGE'">
                  <p style="margin-bottom: 5px;">스페셜 전체 리스트에서 보여질 이미지를 선택해주세요.</p>
                  <div class="file-list">
                    <ul>
                      <li>
                        <div class="attachment">
                          <div class="filebox2">
                            <label for="preview_image">
                              <span>{{ item.previewContentUrl || '파일 선택' }}</span>
                            </label>
                            <input type="file" id="preview_image" @change="selectPreviewImage" accept="image/*"/>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <img v-if="item.previewContentUrl" :src="item.previewContentUrl" style="width: 200px; height: 200px;" alt=""/>
                  </div>
                </div>
                <!-- 비디오 URL 입력 -->
                <div v-else-if="item.previewContentType === 'VIDEO'">
                  <p style="margin-bottom: 5px;">비디오 URL을 입력해주세요 (YouTube, Vimeo 등).</p>
                  <input type="text" v-model="item.previewContentUrl" placeholder="https://example.com/video" style="width: 100%; padding: 8px;"/>
                  <p style="margin-top: 10px; color: #666; font-size: 12px;">예: https://www.youtube.com/watch?v=...</p>
                </div>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top; padding-top: 50px;">메인 컨텐츠 타입<em class="required">*</em></th>
              <td style="padding-top: 50px;">
                <select v-model="item.mainContentType" @change="handleMainContentTypeChange" required>
                  <option value="" disabled>선택해주세요</option>
                  <option value="IMAGE">이미지</option>
                  <option value="VIDEO">비디오</option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top;">메인 컨텐츠</th>
              <td>
                <!-- 이미지 선택 -->
                <div v-if="item.mainContentType === 'IMAGE'">
                  <div class="file-list">
                    <ul>
                      <li>
                        <div class="attachment">
                          <div class="filebox2">
                            <label for="main_image">
                              <span>{{ item.mainContentUrl || '파일 선택' }}</span>
                            </label>
                            <input type="file" id="main_image" @change="selectMainImage" accept="image/*"/>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <img v-if="item.mainContentUrl" :src="item.mainContentUrl" style="width: 200px; height: 200px;" alt=""/>
                  </div>
                </div>
                <!-- 비디오 URL 입력 -->
                <div v-else-if="item.mainContentType === 'VIDEO'">
                  <p style="margin-bottom: 5px;">비디오 URL을 입력해주세요 (YouTube, Vimeo 등).</p>
                  <input type="text" v-model="item.mainContentUrl" placeholder="https://example.com/video" style="width: 100%; padding: 8px;"/>
                  <p style="margin-top: 10px; color: #666; font-size: 12px;">예: https://www.youtube.com/watch?v=...</p>
                </div>
              </td>
            </tr>
            <tr>
              <th>스페셜 타입<em class="required">*</em></th>
              <td>
                <select v-model="item.articleSpecialType" required>
                  <option value="" disabled>선택해주세요</option>
                  <option value="COLUMN">칼럼</option>
                  <option value="INTERVIEW">인터뷰</option>
                  <option value="VIDEO">비디오</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>발행일<em class="required">*</em></th>
              <td>
                <input type="date" v-model="item.publishedAt" required style="width: 200px;"/>
              </td>
            </tr>
            <!-- task 007: '메인 내용'(main_content)은 워드형 본문(content_html) 맨 앞에 합쳐짐 → 중복이라 숨김(데이터/저장 유지) -->
            <tr v-if="false">
              <th>메인 내용</th>
              <td>
                <textarea v-model="item.mainContent"/>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top;">본문 (워드형)</th>
              <td>
                <!-- task 007: 워드형 단일 본문 에디터. v-model = contentHtml -->
                <MimioRichEditor v-model="item.contentHtml" :upload-fn="uploadImage"/>
              </td>
            </tr>
            <tr>
              <th>필자 불러오기</th>
              <td>
                <select v-model="selectedWriterKey" @change="applyWriter" style="max-width: 540px;">
                  <option value="">-- 기존 스페셜 필자 불러오기 --</option>
                  <option v-for="(w, idx) in writerOptions" :key="idx" :value="idx">
                    {{ w.writer }}
                  </option>
                </select>
                <p style="font-size: 12px; color: #999; margin-top: 4px;">
                  선택하면 아래 필자 이미지 · 이름 · 메시지가 자동으로 채워집니다.
                </p>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top;">Writer 이미지</th>
              <td>
                <div class="file-list">
                  <ul>
                    <li>
                      <div class="attachment">
                        <div class="filebox2">
                          <label for="writer_image">
                            <span>{{ item.writerImageUrl }}</span>
                          </label>
                          <input type="file" id="writer_image" @change="selectWriterImage" accept="image/*"/>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <img v-if="item.writerImageUrl" :src="item.writerImageUrl" style="width: 200px; height: 200px;" alt=""/>
                </div>
              </td>
            </tr>
            <tr>
              <th>Writer</th>
              <td>
                <input type="text" v-model="item.writer"/>
              </td>
            </tr>
            <tr>
              <th>Write 메시지</th>
              <td>
                <textarea v-model="item.writerMessage"/>
              </td>
            </tr>
            <!-- task 007: 기존 섹션 리스트는 워드형 에디터(본문)로 대체 — 화면에 안 그림(데이터/저장 로직은 유지) -->
            <tr v-if="false">
              <th style="vertical-align: top;">세부 컨텐츠</th>
              <td>
                <!-- 내용 반복 렌더링 -->
                <div
                    v-for="(contentItem, index) in item.contents"
                    :key="index"
                    style="margin-bottom: 20px; border: 1px solid #e0e0e0; padding: 10px;"
                >
                  <!-- 컨텐츠 타입 선택 -->
                  <div style="margin-bottom: 10px;">
                    <label>컨텐츠 타입<em class="required">*</em></label>
                    <select v-model="contentItem.contentType" required>
                      <option value="" disabled>선택해주세요</option>
                      <option value="IMAGE">이미지</option>
                      <option value="VIDEO">비디오</option>
                    </select>
                  </div>

                  <!-- 컨텐츠 입력 (타입별 조건부 렌더링) -->
                  <div class="file-list">
                    <label>컨텐츠<em class="required">*</em></label>

                    <!-- IMAGE 타입: 파일 업로드 -->
                    <div v-if="contentItem.contentType === 'IMAGE'">
                      <ul>
                        <li>
                          <div class="attachment">
                            <div class="filebox2">
                              <label :for="'contents_image_' + index">
                                <span>{{ contentItem.contentUrl || '파일 선택' }}</span>
                              </label>
                              <input
                                  type="file"
                                  :id="'contents_image_' + index"
                                  @change="selectContentsImage($event, index)"
                                  accept="image/*"
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                      <!-- 미리보기 -->
                      <img
                          v-if="contentItem.contentUrl"
                          :src="contentItem.contentUrl"
                          style="width: 200px; height: 200px; display: block; margin: 10px 0;"
                          alt=""
                      />
                    </div>

                    <!-- VIDEO 타입: URL 입력 -->
                    <div v-else-if="contentItem.contentType === 'VIDEO'">
                      <input
                          type="text"
                          v-model="contentItem.contentUrl"
                          placeholder="https://example.com/video"
                          style="width: 100%; padding: 8px; margin: 10px 0;"
                      />
                    </div>
                  </div>

                  <!-- 제목 입력 -->
                  <div style="margin-top: 10px;">
                    <label>제목</label>
                    <input type="text" v-model="contentItem.title" />
                  </div>

                  <!-- 내용 입력 -->
                  <div style="margin-top: 10px;">
                    <label>내용</label>
                    <textarea v-model="contentItem.content"></textarea>
                  </div>

                  <!-- 삭제 버튼 -->
                  <button
                      type="button"
                      @click="removeContents(index)"
                      class="button red-button small"
                      style="margin-top: 10px;"
                  >
                    삭제
                  </button>
                </div>

                <button
                    type="button"
                    @click="addContents"
                    class="button blue-button small"
                >
                  세부 컨텐츠 추가
                </button>
              </td>
            </tr>
            <tr>
              <th>Home 전시<em class="required">*</em></th>
              <td>
                <select :value="item.isHomeVisible" @change="item.isHomeVisible = $event.target.value === 'true'">
                  <option value="true">공개</option>
                  <option value="false">비공개</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>Home 내용</th>
              <td>
                <textarea v-model="item.homeContent"/>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top;">관련 컨텐츠</th>
              <td>
                <!-- 관련 컨텐츠 반복 렌더링 -->
                <div
                    v-for="(relatedItem, index) in item.relatedContents"
                    :key="index"
                    style="margin-bottom: 20px; border: 1px solid #e0e0e0; padding: 10px;"
                >
                  <!-- 타입 선택 (ARTIST / URL) -->
                  <div style="margin-bottom: 10px;">
                    <label>타입<em class="required">*</em></label>
                    <select v-model="relatedItem.type" required>
                      <option value="" disabled>선택해주세요</option>
                      <option value="ARTIST">아티스트</option>
                      <option value="EXTERNAL_LINK">URL</option>
                    </select>
                  </div>

                  <!-- ARTIST 타입: 계정 선택 -->
                  <div v-if="relatedItem.type === 'ARTIST'">
                    <label>아티스트 선택<em class="required">*</em></label>
                    <SelectArtistUserAccountId v-model:userAccountId="relatedItem.artistUserAccountId" />
                  </div>

                  <!-- EXTERNAL_LINK 타입: URL 입력 -->
                  <div v-else-if="relatedItem.type === 'EXTERNAL_LINK'">
                    <label>컨텐츠 URL<em class="required">*</em></label>
                    <input
                        type="text"
                        v-model="relatedItem.contentUrl"
                        placeholder="https://example.com"
                        style="width: 100%; padding: 8px; margin: 10px 0;"
                    />
                  </div>

                  <!-- 버튼 라벨 (공통) -->
                  <div style="margin-top: 10px;">
                    <label>버튼 라벨<em class="required">*</em></label>
                    <input
                        type="text"
                        v-model="relatedItem.buttonLabel"
                        placeholder="예: 아티스트 보기, 더 알아보기"
                        style="width: 100%; padding: 8px;"
                    />
                  </div>

                  <!-- 삭제 버튼 -->
                  <button
                      type="button"
                      @click="removeRelatedContent(index)"
                      class="button red-button small"
                      style="margin-top: 10px;"
                  >
                    삭제
                  </button>
                </div>

                <button
                    type="button"
                    @click="addRelatedContent"
                    class="button blue-button small"
                >
                  관련 컨텐츠 추가
                </button>

              </td>
            </tr>
            <tr>
              <th>공개여부<em class="required">*</em></th>
              <td>
                <select :value="item.isHidden" @change="item.isHidden = $event.target.value === 'true'">
                  <option value="false">공개</option>
                  <option value="true">비공개</option>
                </select>
              </td>
            </tr>
            <tr v-if="articleUuid">
              <th>생성자</th>
              <td>
                <input type="text" :value="item.createdBy" disabled/>
              </td>
            </tr>
            <tr v-if="articleUuid">
              <th>생성일시</th>
              <td>
                <input type="text" :value="item.createdAt" disabled/>
              </td>
            </tr>
            <tr v-if="articleUuid">
              <th>최종 수정자</th>
              <td>
                <input type="text" :value="item.updatedBy" disabled/>
              </td>
            </tr>
            <tr v-if="articleUuid">
              <th>최종 수정일시</th>
              <td>
                <input type="text" :value="item.updatedAt" disabled/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="button-panel mt30">
        <div class="left">
          <router-link :to="{ name: 'Special'}" class="button white-button round-button gray2">목록</router-link>
        </div>
        <div class="right">
          <button @click="saveItem" type="button" class="button navy-button">{{articleUuid ? '수정하기' : '등록하기'}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {apiClient} from '@/services/auth-header';
import {useRoute} from 'vue-router';
import SelectArtistUserAccountId from '@/components/ui/SelectArtistUserAccountId.vue';
import MimioRichEditor from '@/components/common/MimioRichEditor.vue';

const route = useRoute();
const articleUuid = ref(route.params.uuid);

const item = ref({
  uuid: null,
  title: null,
  subTitle: null,
  previewContentUrl: null,
  previewContentType: 'IMAGE',
  mainContent: null,
  contentHtml: null,
  mainContentUrl: null,
  mainContentType: 'IMAGE',
  articleSpecialType: 'INTERVIEW',
  publishedAt: null,
  writer: null,
  writerMessage: null,
  writerImageUrl: null,
  isHomeVisible: false,
  homeContent : null,
  artistUserAccountId : null,
  isHidden: false,
  createdAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null,
  contents: [],
  relatedContents: [],
})

const selectedPreviewImage = ref(null);
const selectedMainImage = ref(null);
const selectedWriterImage = ref(null);
const API_URL = '/contents';

// 필자 불러오기: 기존 스페셜 필자 목록 + 선택 적용
const writerOptions = ref([]);
const selectedWriterKey = ref('');

const fetchWriterOptions = async () => {
  try {
    const response = await apiClient.get(API_URL + '/articles/specials/writers');
    writerOptions.value = response.data; // [{writer, writerMessage, writerImageUrl}]
  } catch (error) {
    console.error('필자 목록 조회 실패:', error);
  }
};

const applyWriter = () => {
  const w = writerOptions.value[selectedWriterKey.value];
  if (!w) return;
  item.value.writer = w.writer;
  item.value.writerMessage = w.writerMessage;
  item.value.writerImageUrl = w.writerImageUrl; // 기존 이미지 URL 재사용
  selectedWriterImage.value = null; // 새 파일 업로드 없음 → 저장 시 URL 그대로 사용
};

const fetchItem = async () => {
  try {
    const response = await apiClient.get(API_URL + `/articles/specials/${articleUuid.value}`);
    item.value = response.data;

    // ✅ Date 포맷 처리: ISO datetime → date input 호환 형식 (YYYY-MM-DD)
    if (item.value.publishedAt) {
      const dt = new Date(item.value.publishedAt);
      // UTC 시간을 고려하지 않고 로컬 날짜만 추출
      const year = dt.getFullYear();
      const month = String(dt.getMonth() + 1).padStart(2, '0');
      const date = String(dt.getDate()).padStart(2, '0');
      item.value.publishedAt = `${year}-${month}-${date}`;
    }

    // ✅ MODIFIED: Backend에서 relatedUrlType을 받음 (URL 역추적 불필요)
    if (item.value.relatedContents && item.value.relatedContents.length > 0) {
      item.value.relatedContents = item.value.relatedContents.map(rc => {
        // Backend에서 relatedUrlType이 있으면 사용
        if (rc.relatedUrlType) {
          return {
            ...rc,
            type: rc.relatedUrlType
          };
        }

        // 호환성: 기존 데이터 처리 (URL 패턴으로 추론)
        const artistMatch = rc.contentUrl.match(/\/artist\/([a-zA-Z0-9_]+)$/);
        if (artistMatch) {
          return {
            ...rc,
            type: 'ARTIST',
            artistUserAccountId: artistMatch[1],
          };
        } else {
          return {
            ...rc,
            type: 'EXTERNAL_LINK',
            artistUserAccountId: null,
          };
        }
      });
    }
  } catch (error) {
    alert(error.message);
  }
};

const selectPreviewImage = (event) => {
  selectedPreviewImage.value = event.target.files[0];
  item.value.previewContentUrl = URL.createObjectURL(event.target.files[0]);
}

const selectMainImage = (event) => {
  selectedMainImage.value = event.target.files[0];
  item.value.mainContentUrl = URL.createObjectURL(event.target.files[0]);
}

const selectWriterImage = (event) => {
  selectedWriterImage.value = event.target.files[0];
  item.value.writerImageUrl = URL.createObjectURL(event.target.files[0]);
}

const addContents = () => {
  item.value.contents.push({
    contentUrl: null,
    contentType: 'IMAGE',
    title: null,
    content: null,
  });
};

const removeContents = (index) => {
  if (confirm('컨텐츠를 삭제 하시겠습니까?')) {
    item.value.contents.splice(index, 1);
  }
};

const selectContentsImage = (event, index) => {
  const file = event.target.files[0];
  if (file) {
    // 미리보기 URL 설정
    item.value.contents[index].contentUrl = URL.createObjectURL(file);

    // 업로드할 File 객체를 함께 저장 (새로운 프로퍼티 file)
    item.value.contents[index].file = file;
  }
};

const handlePreviewContentTypeChange = () => {
  // 타입 변경 시 이전 blob URL 제거
  if (!item.value.previewContentUrl) return;
  // blob: URL인 경우만 제거 (업로드한 파일)
  if (item.value.previewContentUrl.startsWith('blob:')) {
    item.value.previewContentUrl = null;
  }
};

const handleMainContentTypeChange = () => {
  // 타입 변경 시 이전 blob URL 제거
  if (!item.value.mainContentUrl) return;
  // blob: URL인 경우만 제거 (업로드한 파일)
  if (item.value.mainContentUrl.startsWith('blob:')) {
    item.value.mainContentUrl = null;
  }
};

const addRelatedContent = () => {
  item.value.relatedContents.push({
    type: '',
    buttonLabel: '',
    contentUrl: '',
    artistUserAccountId: '',
  });
};

const removeRelatedContent = (index) => {
  if (confirm('관련 컨텐츠를 삭제 하시겠습니까?')) {
    item.value.relatedContents.splice(index, 1);
  }
};

// 워드형 본문 에디터 인라인 이미지 → S3 업로드 후 URL 반환 (실패 시 에디터가 dataURL fallback)
const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await apiClient.post(API_URL + '/articles/content-image', fd, {
    headers: {'Content-Type': 'multipart/form-data'},
  });
  return res.data.url;
};

const saveItem = async () => {
  if (!validateItem()) {
    return;
  }

  const msg = articleUuid.value ? '수정 하시겠습니까?' : '등록 하시겠습니까?';

  if (confirm(msg)) {
    const formData = new FormData();
    if (selectedPreviewImage.value) {
      formData.append('previewImage', selectedPreviewImage.value);
    }

    if (selectedMainImage.value) {
      formData.append('mainImage', selectedMainImage.value);
    }

    if (selectedWriterImage.value) {
      formData.append('writerImage', selectedWriterImage.value);
    }

    item.value.contents.forEach((content) => {
      if (content.file) {
        formData.append('contentsImages', content.file);
      } else {
        // 파일 없음 표기를 위해 빈 Blob 전송
        const emptyBlob = new Blob([], { type: 'application/octet-stream' });
        formData.append('contentsImages', emptyBlob);
      }
    });

    // API 요청을 위해 boolean 타입 강제 변환
    // publishedAt: date 형식 (YYYY-MM-DD) → LocalDateTime 형식 (YYYY-MM-DDTHH:mm:ss) 변환 (시간은 00:00:00)
    const publishedAtFormatted = item.value.publishedAt
      ? `${item.value.publishedAt}T00:00:00`
      : null;

    const reqDto = {
      uuid: item.value.uuid,
      title: item.value.title,
      subTitle: item.value.subTitle,
      previewContentUrl: item.value.previewContentUrl,
      previewContentType: item.value.previewContentType,
      mainContentUrl: item.value.mainContentUrl,
      mainContent: item.value.mainContent || null,
      contentHtml: item.value.contentHtml || null,
      mainContentType: item.value.mainContentType,
      articleSpecialType: item.value.articleSpecialType,
      publishedAt: publishedAtFormatted,
      writer: item.value.writer,
      writerMessage: item.value.writerMessage,
      writerImageUrl: item.value.writerImageUrl, // 새 파일 없을 때 기존/불러온 이미지 URL 유지·재사용

      isHomeVisible: item.value.isHomeVisible === true || item.value.isHomeVisible === 'true',
      homeContent: item.value.homeContent,
      artistUserAccountId: item.value.artistUserAccountId,
      isHidden: item.value.isHidden === true || item.value.isHidden === 'true',
      contents: item.value.contents.map(c => ({
        uuid: c.uuid || null,
        title: c.title,
        content: c.content,
        contentType: c.contentType,
        // contentUrl은 전송하지 않음 (파일 업로드로 처리)
      })),

      relatedContents: item.value.relatedContents.map(rc => ({
        // ✅ FIXED: id는 이미 저장된 항목만 포함 (null이면 제외)
        ...(rc.id && { id: rc.id }),
        type: rc.type,  // ARTIST or EXTERNAL_LINK
        buttonLabel: rc.buttonLabel,
        artistUserAccountId: rc.type === 'ARTIST' ? rc.artistUserAccountId : null,
        contentUrl: rc.type === 'EXTERNAL_LINK' ? rc.contentUrl : null
      })).filter(rc => rc.buttonLabel && rc.type &&
        (rc.type === 'ARTIST' ? rc.artistUserAccountId : rc.contentUrl)) // 유효한 항목만 전송
    };

    formData.append('reqDto', JSON.stringify(reqDto));

    try {
      if (!articleUuid.value) {
        // 등록
        await apiClient.post(API_URL + '/articles/specials', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        // 수정
        await apiClient.put(API_URL + `/articles/specials/${articleUuid.value}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      const resultMsg = articleUuid.value ? '수정 되었습니다.' : '등록 되었습니다.';
      alert(resultMsg);
      if (articleUuid.value) {
        await fetchItem();
      } else {
        history.back();
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      alert(error.response.data);
    }
  }
};

const validateItem = () => {
  if (!item.value.title) {
    alert('제목은 필수입니다.');
    return false;
  }

  if (!item.value.subTitle) {
    alert('부제목은 필수입니다.');
    return false;
  }

  if (!item.value.previewContentUrl) {
    alert('프리뷰 이미지는 필수입니다.');
    return false;
  }

  if (!item.value.previewContentType || item.value.previewContentType === '') {
    alert('프리뷰 이미지 타입은 필수입니다.');
    return false;
  }

  if (!item.value.mainContentType || item.value.mainContentType === '') {
    alert('메인 이미지 타입은 필수입니다.');
    return false;
  }

  if (!item.value.articleSpecialType || item.value.articleSpecialType === '') {
    alert('스페셜 타입은 필수입니다.');
    return false;
  }

  if (!item.value.publishedAt) {
    alert('발행일시는 필수입니다.');
    return false;
  }

  if (item.value.isHomeVisible === null) {
    alert('Home 전시 여부는 필수입니다.');
    return false;
  }

  if (item.value.isHidden === null) {
    alert('공개여부는 필수입니다.');
    return false;
  }

  // 세부 컨텐츠 검증
  for (let i = 0; i < item.value.contents.length; i++) {
    const content = item.value.contents[i];
    if (!content.contentType || content.contentType === '') {
      alert(`${i + 1}번 컨텐츠의 타입은 필수입니다.`);
      return false;
    }
  }

  return true;
}

onMounted(() => {
  if (articleUuid.value) {
    fetchItem();
  }
  fetchWriterOptions();
});
</script>